<ic-change-language />

<section>
	<ic-granny />

	@if (title) {
		<h1>{{ title }}</h1>
	}
</section>
